export const offeringSummary = {
    name: 'OFFERING SUMMARY',
    rows: []
};

export const incomeAndExpenses = {
    header: ['INCOME & EXPENSES', '', 'CURRENT', 'PSF'],
    rows: [],
    footer: ['NET OPERATING INCOME', '', '' , '']
};

export const rentRoll = {
    header: ['Suite', 'Tenant', 'Sq Ft', '% of SQ FT', 'Start', 'End', 'Annual Rent', 'PSF', 'Escalation Date', 'Escalation Amount', 'Options', 'Lease Type'],
    rows: [],
    footer: [
        ['', 'Occupiedd', '', '', '', '', '', '', '', '', '', ''],
        ['', 'Vacant', '', '', '', '', '', '', '', '', '', ''],
        ['', 'Total', '', '', '', '', '', '', '', '', '', ''],
    ]
};

export const getOfferingSummaryData = function(tabs, precomputedValues) {
    return [{
        label: 'Price',
        value: tabs['marketing-tab'].tables['offering-summary'].rows['price'].getComputedValue(tabs, '', precomputedValues).displayValue
    }, {
        label: 'Cap Rate',
        value: tabs['marketing-tab'].tables['offering-summary'].rows['cap-rate'].getComputedValue(tabs, '', precomputedValues).displayValue
    }, {
        label: 'Net Operating Income',
        value: tabs['marketing-tab'].tables['offering-summary'].rows['net-operating-income'].getComputedValue(tabs, '', precomputedValues).displayValue
    }, {
        label: 'Price PSF',
        value: tabs['marketing-tab'].tables['offering-summary'].rows['price-psf'].getComputedValue(tabs, '', precomputedValues).displayValue
    },{
        label: 'Occupancy',
        value: tabs['marketing-tab'].tables['offering-summary'].rows['occupancy'].getComputedValue(tabs, '', precomputedValues).displayValue
    }, {
        label: 'Year Built',
        value: tabs['marketing-tab'].tables['offering-summary'].rows['year-built'].getComputedValue(tabs, '', precomputedValues).displayValue
    }, {
        label: 'Gross Leasable Area',
        value: tabs['marketing-tab'].tables['offering-summary'].rows['gross-leasable-area'].getComputedValue(tabs, '', precomputedValues).displayValue
    }, {
        label: 'Acres',
        value: tabs['marketing-tab'].tables['offering-summary'].rows['lot-size'].getComputedValue(tabs, '', precomputedValues).displayValue
    }];
};

export const getIncomeAndExpenses = function(tabs, precomputedValues) {
    const incomeExpenses = incomeAndExpenses;
    const rows = tabs['marketing-tab'].tables['income-and-expenses'].rows;
    const keys = Object.keys(rows);
    // remove last element which is an the empty row
    keys.pop();
    incomeExpenses.rows = keys.map(key => {
        return {
            valueCells: new Array(4).fill(null).map((cell, cellIndex) => {
                if (key === 'base-rent-lease-up-space' && cellIndex === 1 || !rows[key].valueCells[cellIndex].hasOwnProperty('getComputedValue')) {
                    return {
                        value: ''
                    }
                }

                if (key === 'mgmt-fee' && cellIndex === 0) {
                    return {
                        value: 'Mgmt. Fee'
                    }
                }
                if (key === 'vacancy-factor' && cellIndex === 0) {
                    return {
                        value: 'Vacancy Factor (economic)'
                    }
                }
                if (key === 'expenses-mgmt-fee' && cellIndex === 0) {
                    return {
                        value: 'Mgmt. Fee (% of GPI)'
                    }
                }

                const value = rows[key].valueCells[cellIndex].getComputedValue(tabs, key, precomputedValues).displayValue;
                const displayValue = value !== '-' ? value : (cellIndex > 1 ? '$0.00' : '0.00%');
                return {
                    value: displayValue
                }
            })
        }
    });

    const footerRow = tabs['marketing-tab'].tables['income-and-expenses'].footerRow;
    incomeExpenses.footer[2] = footerRow.valueCells[2].getComputedValue(tabs, '', precomputedValues).displayValue;
    const psf = footerRow.valueCells[3].getComputedValue(tabs, '', precomputedValues).internalValue;
    incomeExpenses.footer[3] = `$${psf.toLocaleString()}`;

    return incomeExpenses;
};

export const getRentRoll = function(tabs, precomputedValues) {
    const newRentRoll = rentRoll;
    const generalRows = tabs['current-rr-tab'].tables['general-information'].rows;
    const summedGeneralRows = tabs['current-rr-tab'].tables['sumed-general-information'].rows;
    const rentRows = tabs['marketing-tab'].tables['rent-roll'].rows;
    const summedRentRows = tabs['marketing-tab'].tables['sumed-rent-roll'].rows;
    const dateIndexes = [1, 2, 5]; // 1 - Start; 2 - End; 5 - Escalation Date
    const leaseTypeIndex = 8;

    newRentRoll.rows = Object.keys(generalRows).map(key => {
        const valueCells = [];
        let index = 0;

        const cellNo = generalRows[key].valueCells.length;
        generalRows[key].valueCells.map((cell, cellIndex) => {
            if (cellIndex === cellNo - 1 || cellIndex === cellNo - 2)
                return;
            let value = cell.value;
            if (cellIndex === cellNo - 3)
                value = cell.value.toLocaleString();
            valueCells[index] = {value: value};
            index++;
        });

        rentRows[key].valueCells.map((cell, cellIndex) => {
            let value = cell.getComputedValue(tabs, key, precomputedValues).displayValue;
            if (cellIndex === leaseTypeIndex && value.includes('NNN')) {
                valueCells[index] = {value: 'NNN'};
                return;
            }
            if (dateIndexes.includes(cellIndex) && value) {
                value = value.split('');
                value.splice(6, 2);
                value = value.join('');
            }
            valueCells[index] = {value: value};
            index++;
        });

        return {valueCells: valueCells};
    });

    const generalRowsKeys = Object.keys(summedGeneralRows);
    generalRowsKeys.pop();
    generalRowsKeys.map((key, index) => {
        summedGeneralRows[key].valueCells.map((cell, cellIndex) => {
            if (!cell.hasOwnProperty('empty') && cellIndex > 0) {
                newRentRoll.footer[index][cellIndex] = cell.getComputedValue(tabs, key, precomputedValues).displayValue;
            }
        });
    });

    Object.keys(summedRentRows).map((key, index) => {
        summedRentRows[key].valueCells.map((cell, cellIndex) => {
            if (!cell.hasOwnProperty('empty')) {
                newRentRoll.footer[index][cellIndex + generalRowsKeys.length] = cell.getComputedValue(tabs, key, precomputedValues).displayValue;
            }
        });
    });

    return newRentRoll;
};
